import { IFormInscription } from "../types";
import { IDemandeInscriptionCreateData } from "../../../../models/interfaces/IDemandeInscription";
import { buildISBN, convertFilesToFichiersArray } from "./fileHelpers";
import { ETATS_DEMANDE } from "../../../../config/helpers";

/**
 * Transforme les données du formulaire en données pour l'API
 */
export const transformFormDataToAPI = async (
  data: IFormInscription,
  idDemande?: number | null
): Promise<IDemandeInscriptionCreateData> => {
  // Construire l'ISBN complet
  const isbnComplet = buildISBN(
    data.IndicatifISBN,
    data.ISBN1,
    data.ISBN2
  );

  // Convertir les fichiers au format Fichiers[] avec noms originaux
  const fichiers = await convertFilesToFichiersArray(data.PiecesJustificatives);

  return {
    Id: idDemande || undefined,
    IdPays: Number(data.IdPays),
    Siren: data.Siren || undefined,
    RaisonSociale: data.RaisonSociale,
    RaisonSocialeSiren: data.RaisonSocialeSiren || undefined,
    SiteInternet: data.SiteInternet || undefined,
    Adresse: data.Adresse,
    CodePostal: data.CodePostal || undefined,
    Ville: data.Ville || undefined,
    IdCivilite: data.IdCivilite,
    Nom: data.Nom,
    Prenom: data.Prenom,
    Email: data.Email,
    Telephone: data.Telephone || undefined,
    IdFonction: data.Fonction ? Number(data.Fonction) : 1,
    GLNEditeur: data.GLNEditeur,
    Marque: data.MarquePrincipale || undefined,
    IdSecteurActivite: Number(data.IdSecteurActivite),
    ISBN: isbnComplet,
    ISBN13EANComplet: data.ISBN13EANComplet || undefined,
    GLNDiffuseur: data.GLNDiffuseur,
    Commentaires: data.Message || undefined,
    Fichiers: fichiers.length > 0 ? fichiers : undefined,
    AcceptationCGU: data.AcceptationCGU,
    IdEtatDemandeInscription: ETATS_DEMANDE.CREE,
  };
};
